<template>
    <div class="accordion-item" @click="toggleItem">
        <div class="accordion-header">
            <slot name="header"></slot>
            <i :class="['fal', isActive ? closeIcon: openIcon ]"></i>
        </div>
        <collapse-transition>
            <div class="accordion-content" v-show="isActive">
                <slot></slot>
            </div>
        </collapse-transition>
    </div>
</template>

<script>
import { CollapseTransition } from 'vue2-transitions'
export default {
    components: {
        CollapseTransition
    },
    props: {
        openIcon: {
            type: String,
            default: 'fa-angle-down',
            required: false,
        },
        closeIcon: {
            type: String,
            default: 'fa-angle-up',
            required: false,
        }
    },
    data() {
        return {
            isActive: false,
        };
    },
    methods: {
        toggleItem() {
            this.isActive = !this.isActive;
        },
    },
};
</script>
